module.exports = __webpack_public_path__ + "static/media/image04.10fa5816.png";